const bssRoutes = [
  {
    path: '/sign-up',
    name: 'signUp',
    component: () => import('@/views/bss/sign-up'),
    meta: {
      needLogin: true,
      needUserRole: true
    }
  }
]
export default bssRoutes
